import { IPlayerDataLabels, IPlayerResponse } from '../../../../../packages/types';
import { getPlayerStatisticRows } from '../../helpers/getPlayerStatisticRows';

interface INormalizePlayerStatistics {
  statistics?: IPlayerResponse[];
  scheme?: string[];
  season?: string;
  dataLabels?: IPlayerDataLabels;
}

export const normalizePlayerStatistics = ({ statistics, scheme, season, dataLabels }: INormalizePlayerStatistics) => {
  if (!statistics) {
    return { rows: [], seasons: [] };
  }

  const seasons = statistics.map(({ season }) => ({
    label: season.tournament ? `${season.name} ${season.tournament.name}` : season.name,
    value: season.id,
  }));

  const playerStatisticsBySeason = statistics.find((option) => option.season.id === season);

  const rows = getPlayerStatisticRows(playerStatisticsBySeason?.player.position, playerStatisticsBySeason?.statistics, scheme, dataLabels);

  return { rows, seasons };
};
